import "../../styles/reset.css";
import "./NoteControls.css";
import cancel from "../../assets/svg/cancel.svg";
import ColorPicker from "../uiKit/colorPicker/ColorPicker"
import delete_icon from "../../assets/svg/delete.svg";
import save from "../../assets/svg/save.svg";
import React from "react";


class NoteControls extends React.Component {
    render() {
        return (
            <div className="note-controls">
                <ColorPicker handleClickColor={this.props.handleClickColor} color={this.props.color}/>
                <div className="note-controls_right">
                    { this.props.appearances === "EDITABLE" &&
                    <React.Fragment>
                        <button className="icon-button note__button" type="submit"
                                onClick={this.props.handleDelete}>
                            <img src={delete_icon}/>
                        </button>
                    </React.Fragment>
                    }
                    <button className="icon-button new-note__button" type="reset"
                            onClick={this.props.handleReset}>
                        <img src={cancel}/>
                    </button>
                    <button className="icon-button new-note__button" type="submit"
                            onClick={() => this.props.handleSubmit(this.props.color)}>
                        <img src={save}/>
                    </button>
                </div>
            </div>
        );
    }

}

export default NoteControls;
